import { render, staticRenderFns } from "./tkForm.vue?vue&type=template&id=25bc54f6&"
import script from "./tkForm.vue?vue&type=script&lang=js&"
export * from "./tkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tkForm.vue"
export default component.exports